
(function () {
	"use strict";

	function KeyBoardNav() {
		this.buttons = [];
		this.pauseButtons = [];
		this.helpButtons = [];
		this.settingsButtons = [];
		this.keyPressed = null;
		this.spacePressed = false;
		this.selectedButton = null;
		this.navArrow = null;
		this.nonVisible = false;
		this.cycleNum = 0;
	}

	var p = KeyBoardNav.prototype;

	p.keyCheck = function()
	{
		if(cm.ViewControl.currentID === "SpaceView"){
			// this.handleSpaceNav();
		}
		if(cm.Keyboard.state("enterKey") || cm.Keyboard.state("tabKey") || cm.Keyboard.state("space")){
			this.keysUsed = true;
		}

		if(cm.Keyboard.state("enterKey"))
			this.keyPressed = "enterKey";

		if(cm.Keyboard.state("tabKey"))
			this.keyPressed = "tabKey";

		if(cm.Keyboard.state("space"))
			this.keyPressed = "spaceKey";

		if (!cm.Keyboard.state("tabKey") && !cm.Keyboard.state("enterKey") && !cm.Keyboard.state("space")) {
			this.handleKey(this.keyPressed);
			this.keyPressed = null;
		}

	};

	p.handleKey = function(key)
	{
		switch(key){
			case "enterKey":
				if(this.selectedButton && this.navArrow.visible){
					if(cm.ViewControl.current.sharedUI && cm.ViewControl.current.sharedUI.pauseMenuContainer.visible && !cm.ViewControl.current.sharedUI.settingShip.visible)
						{
						cm.ViewControl.current.sharedUI.handleClick(this.selectedButton.name);
						}
					else if(cm.ViewControl.current.sharedUI && cm.ViewControl.current.sharedUI.helpContainer.visible)
						{
							cm.ViewControl.current.sharedUI.handleClick(this.selectedButton.name);
						}
					else if(cm.ViewControl.current.sharedUI && cm.ViewControl.current.sharedUI.settingShip && cm.ViewControl.current.sharedUI.settingShip.visible)
						{
							cm.ViewControl.current.sharedUI.settingShip.handleKeySelect(this.selectedButton);
							return;
						}
					else if(cm.ViewControl.current.settingShip && cm.ViewControl.current.settingShip.visible)
						{
							cm.ViewControl.current.settingShip.handleKeySelect(this.selectedButton);
							return;
						}
					else
						{
							cm.ViewControl.current.keyNavHandle(this.selectedButton);
						}

					this.navArrow.visible = false;
					this.selectedButton = null;
					this.cycleNum = 0;
				}
			break;
			case "tabKey":
				if(cm.ViewControl.current.sharedUI && !cm.ViewControl.current.sharedUI.mouseEnabled || this.buttons.length < 1){
					return;
				}
				this.navArrow.visible = true;

				if(cm.ViewControl.current.sharedUI && cm.ViewControl.current.sharedUI.pauseMenuContainer.visible && !cm.ViewControl.current.sharedUI.settingShip.visible){
					this.selectedButton = this.pauseButtons[this.cycleNum];
					this.cycleNum++;
					if(this.cycleNum > this.pauseButtons.length-1)
						this.cycleNum = 0;
				}
				else if(cm.ViewControl.current.sharedUI && cm.ViewControl.current.sharedUI.helpContainer.visible){
					this.selectedButton = this.helpButtons[this.cycleNum];
					this.cycleNum++;
					if(this.cycleNum > this.helpButtons.length-1)
						this.cycleNum = 0;
				}
				else if(cm.ViewControl.current.settingShip && cm.ViewControl.current.settingShip.visible){
					this.selectedButton = this.settingsButtons[this.cycleNum];
					this.cycleNum++;
					if(this.cycleNum > this.settingsButtons.length-1)
						this.cycleNum = 0;
				} else if(cm.ViewControl.current.sharedUI && cm.ViewControl.current.sharedUI.settingShip && cm.ViewControl.current.sharedUI.settingShip.visible){
					this.selectedButton = this.settingsButtons[this.cycleNum];
					this.cycleNum++;
					if(this.cycleNum > this.settingsButtons.length-1)
						this.cycleNum = 0;
				}
				else if(cm.ViewControl.currentID === "SpaceView" && cm.ViewControl.current.upgradeContainer && cm.ViewControl.current.upgradeContainer.visible){
					this.selectedButton = cm.ViewControl.current.upgradeCloseButtonCont;
					this.cycleNum = 0;
				}
				else{
					this.selectedButton = this.buttons[this.cycleNum];
					this.cycleNum++;
					if(this.cycleNum > this.buttons.length-1)
						this.cycleNum = 0;
				}

				if(this.selectedButton && this.selectedButton.mouseEnabled && this.selectedButton.visible){
					this.placeNavArrow(this.selectedButton);
					if(cm.ViewControl.current.settingShip && !cm.ViewControl.current.settingShip.visible || cm.ViewControl.current.sharedUI && cm.ViewControl.current.sharedUI.settingShip && !cm.ViewControl.current.sharedUI.settingShip.visible){
						this.handleSpaceNav();
					}
				}else{
						if (cm.ViewControl.current.sharedUI && cm.ViewControl.current.sharedUI.helpContainer.visible) {
							for (var i = 0, l = this.helpButtons.length; i < l; i++) {
								var button = this.helpButtons[i];
								if (button.visible) {
									this.handleKey("tabKey");
									return;
								}
							}
						} else if (this.buttons.length > 0) {
							this.handleKey("tabKey");
						}

				}
			break;
			case "spaceKey":
				if(cm.ViewControl.currentID === "CollectionView" || cm.ViewControl.currentID === "StackView"){
					if(cm.ViewControl.current.sharedUI.settingShip.visible || !cm.ViewControl.current.sharedUI.mouseEnabled){return;}
					if(!cm.main.pause){
						cm.ViewControl.current.sharedUI.handleClick("pause-bg");
					} else{
						cm.ViewControl.current.sharedUI.pauseQuit();
					}
				}
			break;
		}
	};

	p.handleSpaceNav =  function()
	{

		if(this.navArrow){
			if(this.selectedButton.name === "settings-bg" || this.selectedButton.name === "stack-button"){
				this.navArrow.x = this.navArrow.x - cm.ViewControl.current.spaceContainer.x;
			}
			else{
				if(cm.ViewControl.currentID === "SpaceView")
					cm.ViewControl.current.checkNavPost();
			}
		}
	};

	p.tabVOHandle = function(name)
	{
		console.log(name);
		//vo that can interrupt
		switch(name){
			case "level-1-map-btn":
				app.voPlayer.play("vo-101");
			break;
			case "level-2-map-btn":
				app.voPlayer.play("vo-102");
			break;
			case "level-3-map-btn":
				app.voPlayer.play("vo-103");
			break;
			case "level-4-map-btn":
				app.voPlayer.play("vo-104");
			break;
			case "level-5-map-btn":
				app.voPlayer.play("vo-105");
			break;
			case "level-6-map-btn":
				app.voPlayer.play("vo-106");
			break;
			case "level-7-map-btn":
				app.voPlayer.play("vo-107");
			break;
			case "level-8-map-btn":
				app.voPlayer.play("vo-108");
			break;
			case "level-9-map-btn":
				app.voPlayer.play("vo-109");
			break;
			case "level-10-map-btn":
				app.voPlayer.play("vo-110");
			break;
			case "level-11-map-btn":
				app.voPlayer.play("vo-32-b");
			break;
		}
		//vo that shouldn't interrupt
			if(app.voPlayer.playing){return;}
		switch(name){
			case "playbtnbg":
				app.voPlayer.play("vo-120");
			break;
			case "skipbg":
				app.voPlayer.play("vo-121");
			break;
			case "settings-bg":
				app.voPlayer.play("vo-128");
			break;
			case "stack-button":
				app.voPlayer.play("vo-127");
			break;
			case "back-to-game":
				app.voPlayer.play("vo-130");
			break;
			case "pause-bg":
				app.voPlayer.play("vo-123");
			break;
			case "help-bg":
				app.voPlayer.play("vo-122");
			break;
			case "close-how-to-btn":
				app.voPlayer.play("vo-164");
			break;
			case "pause-quit":
				app.voPlayer.play("vo-169");
			break;
			case "replay-bg":
			case "replay-btn":
				app.voPlayer.play("vo-165");
			break;
			case "home-btn":
				app.voPlayer.play("vo-170");
			break;
			case "ship-settings":
				app.voPlayer.play("vo-128");
			break;
		}
	};

	p.placeNavArrow = function(button)
	{	var bounds = button.getBounds();
		this.tabVOHandle(button.name);
		switch(button.placeArrow)
		{
			case "right":
				this.navArrow.x = button.x - (bounds.width * 0.5)-30;
				this.navArrow.y = button.y;
				this.navArrow.rotation = 0;
			break;
			case "left":
				this.navArrow.x = button.x + (bounds.width * 0.5)+30;
				this.navArrow.y = button.y;
				this.navArrow.rotation = 180;
			break;
			case "down":
				this.navArrow.x = button.x;
				this.navArrow.y = button.y - (bounds.height * 0.5)-30;
				this.navArrow.rotation = 90;
			break;
			case "up":
				this.navArrow.x = button.x;
				this.navArrow.y = button.y + (bounds.height * 0.5) + 30;
				this.navArrow.rotation = 270;
			break;
		}
	};

	p.removeEventsOnButtons = function () {
		var i;
		
		for (i = 0; i < this.buttons.length; i++ ) {
			this.buttons[i].removeAllEventListeners();
		}
		for (i = 0; i < this.helpButtons.length; i++ ) {
			this.helpButtons[i].removeAllEventListeners();
		}
		for (i = 0; i < this.settingsButtons.length; i++ ) {
			this.settingsButtons[i].removeAllEventListeners();
		}
	};

	cm.KeyBoardNav = KeyBoardNav;
})();